import moment from 'moment'
import { isDefined } from '@/utils/isDefined'
// changed to fix build after renaming from 'DateUtilities' -> 'dateUtilities'
export const utcOffset = +3
export const defaultDateFormat = 'DD/MM/YYYY' // moment format symbols: http://momentjs.com/docs/#/displaying/format/
export const defaultDateTimeFormat = 'DD/MM/YYYY HH:mm'
export const defaultDateTimeSecondFormat = 'DD/MM/YYYY HH:mm:ss'

export const formatDate = (date, format) => {
  if (date) {
    return moment.parseZone(date).utcOffset(utcOffset).format(format || defaultDateFormat)
  }
  return null
}

export const fromUtcDate = date => date ? moment.utc(date).toDate() : date
export const toUtcDate = date => date ? new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())) : date

// Transforms local to UTC system time
export const fromLocalToSystemTime = momentDate => isDefined(momentDate) ? momentDate.add((momentDate.utcOffset() / 60) - utcOffset, 'h').utcOffset(utcOffset) : null

export const getMomentLocalDate = date => date ? moment(date) : date

export const convertIsoStringsToDates = (item, propertyNames = []) => {
  if (item) {
    const x = { ...item }
    propertyNames.forEach(name => {
      if (x.hasOwnProperty(name)) {
        x[name] = (x[name] ? fromUtcDate(x[name]) : x[name])
      }
    })
    return x
  }
  return item
}



// WEBPACK FOOTER //
// ./src/utils/dateUtilities.js